import { Redirect, Route, RouteProps } from "react-router";
import { useAppSelector } from "../app/hooks";
import { appPath } from "./AppRoute";

export const InputBranchRoute = (props: RouteProps): JSX.Element => {
  const isCommonQR = useAppSelector(
    (state): boolean =>
      !!state.inputAnswer.session.cxHttpRes?.data?.cxAppSession.shopqr?.token
        ?.isCommon
  );

  return !isCommonQR ? (
    <Redirect to={appPath.shopqr.couponIntro} />
  ) : (
    <Route {...props} />
  );
};
